$(document).ready(() => {
  $("#tab_payment_methods").show();
});

// hide all tabs, shows given tab name
// types 'bank_acct' | 'credit_card' | 'wallet' | 'payment_methods'
window.hideTabsCheckout = (show = "") => {
  const tabs = $(".tab-pane");
  tabs.each((i, e) => {
    if (show !== "" && $(e).attr("id") === `tab_${show}`) {
      $(e).show();
    } else {
      $(e).hide();
    }
  });
};
